export * from './baCard.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baCard/index.ts